module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder2-70b58eea.svg";